import type { JSX } from "react";

import { MarkdownViewer } from "@expert/solve-tools";
import { Box, Divider, Group, Stack, Text } from "@mantine/core";

import { markdownOverrides } from "./markdownOverrides";
import { OpeningQuote } from "./OpeningQuote";
import classes from "./styles.module.css";

interface ConversationalSummaryProps {
    conversationalSummary: string;
    customerName?: string;
}
export function ConversationalSummary({
    conversationalSummary,
    customerName,
}: ConversationalSummaryProps): JSX.Element {
    return (
        <Stack gap="xs">
            <Stack className={classes.conversationalSummary} gap="xs" p="xs">
                <Text c="dark.7">
                    Greet{" "}
                    {customerName ? (
                        <Text span fw="bold" className="fs-mask">
                            {customerName}
                        </Text>
                    ) : (
                        "them"
                    )}{" "}
                    by saying this:
                </Text>
                <Group gap="3xs" color="dark.7" wrap="nowrap" align="flex-start" style={{ flex: 1, minWidth: 0 }}>
                    <Divider orientation="vertical" color="dark.7" size="xs" />
                    <Box w={24}>
                        <OpeningQuote width={18} height={18} fill="dark.7" style={{ display: "block" }} />
                    </Box>
                    <Stack>
                        <MarkdownViewer
                            content={
                                customerName && conversationalSummary.includes(customerName)
                                    ? conversationalSummary.replaceAll(
                                          customerName,
                                          `<span class="fs-mask">${customerName}</span>`,
                                      )
                                    : conversationalSummary
                            }
                            options={{ overrides: markdownOverrides, forceBlock: true }}
                        />
                    </Stack>
                </Group>
            </Stack>
        </Stack>
    );
}
